/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "COMMENT_SEEN" | "CONFIGURE_PUBLIC_PROFILE_URL" | "COUNTS_V2" | "DATA_CACHE" | "DEFAULT_QA_STORY_MODE" | "DISABLE_LIVE_UPDATES" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "EMAIL_META" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "VIEWER_COUNT" | "Z_KEY" | "%future added value";
export type ReplyListCommentContainer_settings = {
    readonly flattenReplies: boolean;
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
    readonly " $refType": "ReplyListCommentContainer_settings";
};
export type ReplyListCommentContainer_settings$data = ReplyListCommentContainer_settings;
export type ReplyListCommentContainer_settings$key = {
    readonly " $data"?: ReplyListCommentContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flattenReplies",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '62845d86d4cbeec3eea465eb031ea321';
export default node;
